import React, { useEffect, useState } from 'react';
import './MarketplaceBrokerChatTab.scss';
import { TimelineParty } from '../../../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { Timeline } from '../../../../../../slices/marketplace/timeline/models/timeline.model';
import ClubhouseArea from '../../../../../../clubhouse/clubhouse-area/clubhouse-area';
import { MessageReference } from '../../../../../../clubhouse/models/message-reference';
import { GroupType } from '../../../../../../clubhouse/models/group-type';
import { useStateSelector } from '../../../../../../store/selectors';
import { USER_ROLES } from '../../../../../../utils/constants';
import { useSearchParams } from 'react-router-dom';
import { QueryParams } from '../../../../../../utils/queryParams';
import { NotificationFlagsCategories } from '../../../../../../models/NotificationFlags/NotificationFlagsCategories';
import { EngagementProcessStatus } from '../../../../../../slices/marketplace/timeline/models/enums/engagement-process-status.enum';

interface MarketplaceBrokerChatTabProps {
    party: TimelineParty;
    timeline: Timeline;
}

export const MarketplaceBrokerChatTab = (
    props: MarketplaceBrokerChatTabProps
) => {
    const [messageReference, setMessageReference] = useState<
        MessageReference | undefined
    >();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isForbiddenError, setIsForbiddenError] = useState(false);
    const [isUnexpectedError, setIsUnexpectedError] = useState(false);
    const [searchParams] = useSearchParams();
    const isUserAdmin =
        useStateSelector((s) => s.currentUser.user.roleId) === USER_ROLES.ADMIN;

    return (
        <div className="marketplace-broker-chat-tab marketplace-dynamic-container">
            <div className="body_inner_content marketplace-dynamic-container">
                <div className="clubhouse-dynamic-container">
                    <div className="app-pmg-clubhouse app-clubhouse-page">
                        {isForbiddenError ? (
                            <h2 className="error-message">
                                You're not authorized to view this page
                            </h2>
                        ) : isUnexpectedError ? (
                            <h2 className="error-message">
                                Unexpected error occured while fetching
                                Clubhouse
                            </h2>
                        ) : (
                            <div className="flex-container">
                                <ClubhouseArea
                                    messageReference={messageReference}
                                    resetMessageReference={() => {
                                        setMessageReference(undefined);
                                    }}
                                    clubhouseId={
                                        props.timeline.engagementProcess.broker
                                            .brokerChatId
                                    }
                                    groupType={GroupType.MP}
                                    isAdmin={isUserAdmin}
                                    isDataLoading={isDataLoading}
                                    setIsDataLoading={setIsDataLoading}
                                    isActive={isActive}
                                    setIsActive={setIsActive}
                                    setIsForbiddenError={setIsForbiddenError}
                                    refreshClubhouseData={() => {}}
                                    setIsUnexpectedError={setIsUnexpectedError}
                                    isDisabledMessageInput={
                                        props.timeline.engagementProcess
                                            .status !==
                                        EngagementProcessStatus.Current
                                    }
                                    isDisabledLikeButton={
                                        props.timeline.engagementProcess
                                            .status !==
                                        EngagementProcessStatus.Current
                                    }
                                    isKbAvailable={false}
                                    preselectedDiscussionId={Number(
                                        searchParams.get(
                                            QueryParams.DiscussionIdKey
                                        )
                                    )}
                                    displayTopLikedPosts={() => {}}
                                    customDiscussionsName="Thread"
                                    isDisscussionDeleteIconVisible={true}
                                    customNfPrefix={`${NotificationFlagsCategories.MpCode}.${props.timeline.id}.${NotificationFlagsCategories.CommsHubCode}.${NotificationFlagsCategories.BrokerChatCode}.${props.timeline.engagementProcess.broker.brokerChatId}`}></ClubhouseArea>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
